import { useDialog } from '@packages/ui/modal/use-dialog';
import { useNavigate } from 'react-router-dom';
import { useCallback } from 'react';
import CardSection from '@packages/ui/card/card-section';
import DestroyButton from '@packages/ui/button/destroy-button';
import { useTranslate } from '@tolgee/react';
import useDeleteService from '@client/page/management/appointment/service/service-product/service-product-edit/logic/use-delete-service.ts';

export default function ServiceMenuDelete(props: { serviceId: string }) {
  const navigate = useNavigate();
  const { t } = useTranslate();
  const dialog = useDialog();
  const [deleteService] = useDeleteService();

  const onDestroy = useCallback(() => {
    dialog.destructAlert({
      title: t('service.service-detail.product.edit.extra-action.delete.alert.title'),
      message: t('service.service-detail.product.edit.extra-action.delete.alert.message'),
      textButton: t('service.service-detail.product.edit.extra-action.delete.alert.text-button'),
      onConfirm: async () => {
        await deleteService({ variables: { id: props.serviceId } });
        navigate('../..');
      },
    });
  }, [deleteService, dialog, navigate, props.serviceId, t]);

  return (
    <div className="flex space-x-4">
      <CardSection
        title={t('service.service-detail.product.edit.extra-action.delete.title')}
        descriptions={t('service.service-detail.product.edit.extra-action.delete.description')}
      >
        <DestroyButton data-testid="delete-button" onClick={onDestroy}>
          {t('service.service-detail.product.edit.extra-action.delete.button')}
        </DestroyButton>
      </CardSection>
    </div>
  );
}
